import { render, staticRenderFns } from "./TiptapDraghandle.vue?vue&type=template&id=7caed33c&"
import script from "./TiptapDraghandle.vue?vue&type=script&lang=js&"
export * from "./TiptapDraghandle.vue?vue&type=script&lang=js&"
import style0 from "./TiptapDraghandle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports